export default "__VITE_ASSET__bfTKi0av__"